import React from "react";

import { getPreviewFramePrintFontSize } from "@/utils/qrEditorHelper";

import { QRFRameToPrintProps } from "../types";

import { uriText } from "./uri";

import "../styles.scss";

export const TicketsFrameToDownload = (
  props: QRFRameToPrintProps
): React.SVGProps<SVGSVGElement> => {
  const {
    text,
    textColor,
    frameColor,
    frameBackgroundColor,
    height = 1200,
    qrSvg,
    width = 900,
  } = props;

  const fontSize = getPreviewFramePrintFontSize(text?.length);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none">
      <style>
        {`
              @font-face {
                font-family: 'Nunito Sans';
                src: url(${uriText});
                font-weight: bold
              }
            `}
      </style>
      <g id="surface1">
        <path
          fillRule="nonzero"
          fill="white"
          fillOpacity="1"
          strokeWidth="1"
          stroke="#BFBFBF"
          d="M 8 0.5 L 87.999997 0.5 C 92.142081 0.5 95.499997 3.857799 95.499997 8.000001 L 95.499997 120.000011 C 95.499997 124.142213 92.142081 127.500012 87.999997 127.500012 L 8 127.500012 C 3.857917 127.500012 0.5 124.142213 0.5 120.000011 L 0.5 8.000001 C 0.5 3.857799 3.857917 0.5 8 0.5 Z M 8 0.5 "
          transform="matrix(9.375,0,0,9.367187,0,0)"
        />

        <path
          stroke="none"
          fillRule="nonzero"
          fill={frameBackgroundColor}
          d="M 112.5 93.671875 L 637.5 93.671875 C 647.855469 93.671875 656.25 102.058594 656.25 112.40625 L 656.25 636.96875 C 656.25 647.316406 647.855469 655.703125 637.5 655.703125 L 112.5 655.703125 C 102.144531 655.703125 93.75 647.316406 93.75 636.96875 L 93.75 112.40625 C 93.75 102.058594 102.144531 93.671875 112.5 93.671875 Z M 112.5 93.671875 "
        />

        <path
          stroke="none"
          fillRule="evenodd"
          fill={frameColor}
          d="M 796.875 640.773438 C 796.875 643.996094 796.875 647.214844 796.875 650.433594 C 782.828125 658.277344 779.875 669.011719 788.011719 682.632812 C 790.410156 685.304688 793.363281 686.917969 796.875 687.460938 C 796.875 691.757812 796.875 696.050781 796.875 700.34375 C 782.828125 708.1875 779.875 718.921875 788.011719 732.542969 C 790.410156 735.214844 793.363281 736.824219 796.875 737.371094 C 796.875 742.203125 796.875 747.035156 796.875 751.863281 C 793.363281 752.410156 790.410156 754.019531 788.011719 756.695312 C 779.851562 770.21875 782.804688 780.953125 796.875 788.890625 C 796.875 792.113281 796.875 795.332031 796.875 798.550781 C 783.578125 801.90625 775.523438 810.226562 772.707031 823.507812 C 673.941406 865.792969 575.113281 907.921875 476.21875 949.886719 C 472.734375 945.074219 468.4375 941.046875 463.332031 937.816406 C 456.832031 937.253906 450.652344 936.980469 444.800781 937.011719 C 443.996094 934.597656 443.1875 932.183594 442.382812 929.765625 C 453.5 910.246094 448.128906 897.636719 426.269531 891.929688 C 424.742188 889.421875 423.671875 886.738281 423.046875 883.882812 C 433.8125 864.359375 428.441406 851.75 406.933594 846.046875 C 405.117188 843.226562 403.507812 840.269531 402.101562 837.191406 C 411.214844 825.570312 410.679688 814.566406 400.488281 804.1875 C 394.726562 802.238281 389.355469 799.828125 384.375 796.941406 C 384.375 794.796875 384.375 792.648438 384.375 790.5 C 388.492188 788.824219 391.984375 786.140625 394.851562 782.453125 C 397.210938 775.445312 398.015625 768.46875 397.265625 761.523438 C 406.640625 757.640625 415.773438 753.347656 424.660156 748.644531 C 425.730469 745.421875 426.808594 742.203125 427.878906 738.980469 C 440 732.472656 443.492188 722.808594 438.351562 710.003906 C 435.316406 705.589844 431.285156 702.90625 426.269531 701.953125 C 425.757812 697.007812 426.292969 692.175781 427.878906 687.460938 C 440 680.953125 443.492188 671.289062 438.351562 658.484375 C 435.316406 654.070312 431.285156 651.386719 426.269531 650.433594 C 425.789062 647.046875 426.324219 643.828125 427.878906 640.773438 C 440.449219 638.417969 447.429688 630.902344 448.828125 618.234375 C 557.863281 618.234375 666.894531 618.234375 775.925781 618.234375 C 777.273438 630.851562 784.253906 638.367188 796.875 640.773438 Z M 796.875 640.773438 "
        />
        <path
          stroke="none"
          fillRule="evenodd"
          fill={"white"}
          d="M 478.636719 657.679688 C 566.726562 657.679688 654.808594 657.679688 742.898438 657.679688 C 742.898438 698.46875 742.898438 739.253906 742.898438 780.039062 C 654.808594 780.039062 566.726562 780.039062 478.636719 780.039062 C 478.636719 739.253906 478.636719 698.46875 478.636719 657.679688 Z M 478.636719 657.679688 "
        />
        <path
          stroke="none"
          fillRule="evenodd"
          fill={frameColor}
          d="M 731.617188 668.949219 C 731.617188 702.222656 731.617188 735.496094 731.617188 768.765625 C 651.046875 768.765625 570.484375 768.765625 489.917969 768.765625 C 489.917969 735.496094 489.917969 702.222656 489.917969 668.949219 C 570.484375 668.949219 651.046875 668.949219 731.617188 668.949219 Z M 731.617188 668.949219 "
        />
        <path
          stroke="none"
          fillRule="evenodd"
          fill={"white"}
          d="M 575.316406 694.707031 C 582.464844 694.238281 589.445312 695.046875 596.265625 697.125 C 598.710938 699.300781 600.859375 701.714844 602.710938 704.371094 C 600.5625 705.980469 598.414062 707.589844 596.265625 709.199219 C 586.570312 699.921875 578.246094 700.992188 571.289062 712.417969 C 568.5625 727.734375 574.742188 734.445312 589.820312 732.542969 C 593.210938 731.269531 595.355469 728.855469 596.265625 725.300781 C 598.414062 726.910156 600.5625 728.519531 602.710938 730.128906 C 593.300781 742.703125 582.023438 744.582031 568.875 735.761719 C 556.8125 719.785156 558.960938 706.097656 575.316406 694.707031 Z M 575.316406 694.707031 "
        />
        <path
          stroke="none"
          fillRule="evenodd"
          fill={"white"}
          d="M 509.253906 696.320312 C 521.070312 696.320312 532.886719 696.320312 544.703125 696.320312 C 544.703125 699 544.703125 701.683594 544.703125 704.371094 C 539.867188 704.371094 535.03125 704.371094 530.203125 704.371094 C 530.203125 716.710938 530.203125 729.054688 530.203125 741.398438 C 527.515625 741.398438 524.828125 741.398438 522.144531 741.398438 C 522.144531 729.054688 522.144531 716.710938 522.144531 704.371094 C 517.847656 704.371094 513.550781 704.371094 509.253906 704.371094 C 509.253906 701.683594 509.253906 699 509.253906 696.320312 Z M 509.253906 696.320312 "
        />
        <path
          stroke="none"
          fillRule="evenodd"
          fill={"white"}
          d="M 547.925781 696.320312 C 550.609375 696.320312 553.296875 696.320312 555.980469 696.320312 C 555.980469 711.34375 555.980469 726.371094 555.980469 741.398438 C 553.296875 741.398438 550.609375 741.398438 547.925781 741.398438 C 547.925781 726.371094 547.925781 711.34375 547.925781 696.320312 Z M 547.925781 696.320312 "
        />
        <path
          stroke="none"
          fillRule="evenodd"
          fill={"white"}
          d="M 605.933594 696.320312 C 608.617188 696.320312 611.304688 696.320312 613.988281 696.320312 C 613.722656 702.246094 613.988281 708.148438 614.796875 714.027344 C 619.058594 708.425781 623.621094 703.058594 628.492188 697.929688 C 632.25 695.78125 636.011719 695.78125 639.769531 697.929688 C 633.460938 703.957031 628.085938 710.664062 623.65625 718.050781 C 628.929688 726.007812 634.835938 733.523438 641.382812 740.59375 C 638.160156 741.667969 634.9375 741.667969 631.710938 740.59375 C 626.015625 735.441406 620.914062 729.804688 616.40625 723.6875 C 614.125 729.257812 613.320312 735.160156 613.988281 741.398438 C 611.304688 741.398438 608.617188 741.398438 605.933594 741.398438 C 605.933594 726.371094 605.933594 711.34375 605.933594 696.320312 Z M 605.933594 696.320312 "
        />
        <path
          stroke="none"
          fillRule="evenodd"
          fill={"white"}
          d="M 673.609375 696.320312 C 673.609375 698.46875 673.609375 700.613281 673.609375 702.757812 C 666.304688 702.246094 659.324219 702.78125 652.660156 704.371094 C 652.660156 707.589844 652.660156 710.808594 652.660156 714.027344 C 660.179688 714.027344 667.699219 714.027344 675.21875 714.027344 C 675.21875 716.710938 675.21875 719.394531 675.21875 722.078125 C 667.699219 722.078125 660.179688 722.078125 652.660156 722.078125 C 652.660156 725.835938 652.660156 729.589844 652.660156 733.347656 C 659.324219 734.933594 666.304688 735.472656 673.609375 734.957031 C 673.609375 737.105469 673.609375 739.253906 673.609375 741.398438 C 663.941406 741.398438 654.273438 741.398438 644.605469 741.398438 C 644.605469 726.371094 644.605469 711.34375 644.605469 696.320312 C 654.273438 696.320312 663.941406 696.320312 673.609375 696.320312 Z M 673.609375 696.320312 "
        />
        <path
          stroke="none"
          fillRule="evenodd"
          fill={"white"}
          d="M 678.441406 696.320312 C 690.257812 696.320312 702.078125 696.320312 713.890625 696.320312 C 713.890625 699 713.890625 701.683594 713.890625 704.371094 C 709.054688 704.371094 704.226562 704.371094 699.390625 704.371094 C 699.390625 716.710938 699.390625 729.054688 699.390625 741.398438 C 696.703125 741.398438 694.019531 741.398438 691.332031 741.398438 C 691.332031 729.054688 691.332031 716.710938 691.332031 704.371094 C 687.035156 704.371094 682.742188 704.371094 678.441406 704.371094 C 678.441406 701.683594 678.441406 699 678.441406 696.320312 Z M 678.441406 696.320312 "
        />
        <path
          stroke="none"
          fillRule="evenodd"
          fill={"white"}
          d="M 673.609375 696.320312 C 675.140625 698.605469 675.679688 701.285156 675.21875 704.371094 C 667.699219 704.371094 660.179688 704.371094 652.660156 704.371094 C 659.324219 702.78125 666.304688 702.246094 673.609375 702.757812 C 673.609375 700.613281 673.609375 698.46875 673.609375 696.320312 Z M 673.609375 696.320312 "
        />
        <path
          stroke="none"
          fillRule="evenodd"
          fill={"white"}
          d="M 652.660156 733.347656 C 660.179688 733.347656 667.699219 733.347656 675.21875 733.347656 C 675.679688 736.429688 675.140625 739.113281 673.609375 741.398438 C 673.609375 739.253906 673.609375 737.105469 673.609375 734.957031 C 666.304688 735.472656 659.324219 734.933594 652.660156 733.347656 Z M 652.660156 733.347656 "
        />
        <path
          stroke="none"
          fillRule="evenodd"
          fill={frameColor}
          d="M 731.617188 668.949219 C 733.222656 702.480469 733.761719 736.289062 733.226562 770.378906 C 651.851562 770.914062 570.746094 770.375 489.917969 768.765625 C 570.484375 768.765625 651.046875 768.765625 731.617188 768.765625 C 731.617188 735.496094 731.617188 702.222656 731.617188 668.949219 Z M 731.617188 668.949219 "
        />
        <path
          stroke="none"
          fillRule="evenodd"
          fill={frameColor}
          d="M 572.09375 821.898438 C 563.8125 820.308594 555.21875 819.769531 546.3125 820.285156 C 554.765625 818.4375 564.433594 818.171875 575.316406 819.480469 C 574.441406 820.636719 573.367188 821.441406 572.09375 821.898438 Z M 572.09375 821.898438 "
        />
        <path
          stroke="none"
          fillRule="evenodd"
          fill={frameColor}
          d="M 644.605469 820.285156 C 654.519531 818.429688 664.722656 818.164062 675.21875 819.480469 C 673.566406 820.308594 671.953125 821.113281 670.382812 821.898438 C 662.105469 820.308594 653.507812 819.769531 644.605469 820.285156 Z M 644.605469 820.285156 "
        />
        <path
          stroke="none"
          fillRule="evenodd"
          fill={"white"}
          d="M 644.605469 820.285156 C 653.507812 819.769531 662.105469 820.308594 670.382812 821.898438 C 609.539062 847.191406 548.84375 872.953125 488.304688 899.175781 C 486.214844 898.226562 484.871094 896.617188 484.277344 894.347656 C 474.109375 869.769531 463.636719 845.351562 452.859375 821.089844 C 457.25 819.777344 461.546875 820.042969 465.746094 821.898438 C 474.984375 842.625 483.578125 863.554688 491.53125 884.6875 C 542.476562 863.238281 593.503906 841.769531 644.605469 820.285156 Z M 644.605469 820.285156 "
        />
        <path
          stroke="none"
          fillRule="evenodd"
          fill={"white"}
          d="M 572.09375 821.898438 C 563.8125 820.308594 555.21875 819.769531 546.3125 820.285156 C 554.40625 826.121094 563 826.65625 572.09375 821.898438 Z M 572.09375 821.898438 "
        />
        <path
          stroke="none"
          fillRule="evenodd"
          fill={"white"}
          d="M 528.589844 820.285156 C 531.8125 820.285156 535.03125 820.285156 538.257812 820.285156 C 538.847656 824.160156 539.921875 827.917969 541.480469 831.558594 C 540.089844 835.207031 537.40625 836.816406 533.421875 836.386719 C 531.8125 831.019531 530.203125 825.65625 528.589844 820.285156 Z M 528.589844 820.285156 "
        />
        <path
          stroke="none"
          fillRule="evenodd"
          fill={"white"}
          d="M 501.195312 820.285156 C 504.367188 819.902344 507.320312 820.441406 510.058594 821.898438 C 513.011719 828.875 515.96875 835.851562 518.921875 842.828125 C 516.554688 845.777344 513.867188 846.316406 510.867188 844.4375 C 507.175781 836.53125 503.949219 828.484375 501.195312 820.285156 Z M 501.195312 820.285156 "
        />

        <g
          stroke="null"
          transform="matrix(6.2212 0 0 6.2212 0 -55)"
          id="svg_485">
          <g
            dangerouslySetInnerHTML={{ __html: qrSvg }}
            stroke="null"
            id="svg_486"></g>
        </g>
        <text
          x="450"
          y="1050.3999700784689"
          dominantBaseline="middle"
          textAnchor="middle"
          fill={textColor}
          fontFamily="Nunito Sans"
          style={{ fontSize }}>
          {text}
        </text>
      </g>
    </svg>
  );
};
